<template>
	<modal class="custom-product-modal" :modalOpen="modalOpen" ref="modalContainer" @close="$emit('close')">
		<div slot="header">{{ customProductData.task }} your own product</div>
		<div class="content">
			<ValidationObserver ref="customProduct">
				<ValidationProvider name="custom-product-details" rules="customProductDesc" v-slot="{errors}">
					<input-area
						name="custom-product-details"
						label="Your Own Product"
						maxlength="400"
						tag="textarea"
						v-model="cpValue"
						id="custom-product-details"
						placeholder="Your own product"
						:isVisible="modalOpen"
						:error="errors[0]"
					/>
				</ValidationProvider>
			</ValidationObserver>
		</div>
		<div class="footer" slot="footer">
			<md-button class="md-primary md-button-large customProduct--cancel" @click.stop="$emit('close')">
				Cancel
			</md-button>
			<md-button class="md-primary md-raised md-button-large has-icon apply-product" @click="validateForm">
				<base-icon class="check" icon-name="check" />
				{{ customProductData.task === 'edit' ? 'Save' : 'Add product' }}
			</md-button>
		</div>
	</modal>
</template>

<script>
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {trackEvent} from '@/services/tracking.js';

extend('customProductDesc', {
	message: 'This field is required.',
	validate(value) {
		return {
			valid: value?.length > 0,
		};
	},
	computesRequired: true,
});

export default {
	name: 'CustomProductModal',
	components: {
		ValidationProvider,
		ValidationObserver,
	},
	props: {
		modalOpen: {
			type: Boolean,
		},
		customProductData: {
			type: Object,
		},
	},
	data() {
		return {
			cpValue: null,
		};
	},
	created() {
		this.$root.$emit('closeGlobalBanner');
	},
	mounted() {
		this.cpValue = this.customProductData.desc;
	},
	methods: {
		async validateForm() {
			const validate = await this.$refs.customProduct.validate().then((success) => success);
			if (!validate) return;
			this.createCustomProduct();
		},
		createCustomProduct() {
			trackEvent('ctaClick', {eVar58: 'Add your own product | Workflow Configurator'});
			const {task, key, stepName, productIndex} = this.customProductData;
			const customProductVals = {
				desc: this.cpValue,
				task,
				key,
				stepName,
				productIndex,
			};
			this.$emit('customProductVal', customProductVals);
			this.cpValue = '';
			this.$root.$emit('changeRegistered');
			this.$emit('close');
		},
	},
};
</script>

<style lang="scss" scoped>
.custom-product-modal {
	.header {
		div::first-letter {
			text-transform: capitalize;
		}
	}
	.content {
		@include flexColumn;
		position: relative;
		::v-deep {
			.md-invalid {
				#custom-product-details {
					border-color: $color-red;
				}
			}
		}
		label {
			position: absolute;
			left: 12px;
			top: -10px;
			padding: 0 2px;
			background-color: white;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		textarea {
			border: 1px solid $color-grey;
			border-radius: 10px;
			min-height: 108px;
			padding: 10px 12px;
			&:focus,
			&:active {
				outline: none;
			}
		}
		span.md-count {
			height: 20px;
			font-size: 12px;
			transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
			text-align: end;
			margin-top: 4px;
		}
	}
	.footer {
		@include flexRow;
		justify-content: flex-end;
		width: 100%;
		button:nth-child(1) {
			margin-right: 8px;
		}
	}
	@media (max-width: $mobile) {
		::v-deep {
			.modal-container {
				padding: 16px;
				min-height: 0px;
				.display-2 {
					padding-bottom: 12px;
				}
				.content {
					overflow: initial;
					margin-bottom: 20px;
				}
			}
		}
	}
}
</style>
